import { useI18n } from 'vue-i18n'
import { JobMatchStatus } from '@/api/job-match'
import type { JobInfoTag } from '@/components/business-components/job-info/types'

// 未沟通（NOT_COMMUNICATED）、推荐等不展示标签
const MATCH_TAGS: Partial<Record<JobMatchStatus, { labelKey: string; type: JobInfoTag['type'] }>> = {
  [JobMatchStatus.PENDING_APPLY]: { labelKey: 'jobMatch.tabs.pendingApply', type: 'success' },
  [JobMatchStatus.COMMUNICATING]: { labelKey: 'jobMatch.tabs.communicating', type: 'primary' },
  [JobMatchStatus.NOT_CONSIDER]: { labelKey: 'jobMatch.tabs.notConsider', type: 'info' },
}

// 排序权重：待投递 → 沟通中 → 无标签 → 暂不考虑
const MATCH_SORT_WEIGHT: Partial<Record<JobMatchStatus, number>> = {
  [JobMatchStatus.PENDING_APPLY]: 0,
  [JobMatchStatus.COMMUNICATING]: 1,
  [JobMatchStatus.NOT_CONSIDER]: 3,
}
const NO_TAG_WEIGHT = 2

/**
 * 职位选项上的岗位匹配状态标签（投递弹窗、添加沟通职位弹窗共用）：
 * - matchTag：状态对应的 JobInfo 标签
 * - sortByMatchStatus：按「待投递 → 沟通中 → 无标签 → 暂不考虑」排序，同组内按求人创建时间由近及远
 */
export function useJobMatchTag() {
  const { t } = useI18n()

  const matchTag = (status?: JobMatchStatus | null): JobInfoTag | undefined => {
    const tag = status ? MATCH_TAGS[status] : undefined
    return tag ? { text: t(tag.labelKey), type: tag.type } : undefined
  }

  const sortByMatchStatus = <T extends { matchStatus?: JobMatchStatus | null; createTime?: string }>(list: T[]): T[] => {
    const weight = (job: T) => (job.matchStatus && MATCH_SORT_WEIGHT[job.matchStatus]) ?? NO_TAG_WEIGHT
    // Array.sort 稳定，接口没给创建时间时保持原顺序
    return [...list].sort((a, b) => weight(a) - weight(b) || (b.createTime || '').localeCompare(a.createTime || ''))
  }

  return { matchTag, sortByMatchStatus }
}
